/* ════════════════════════════════════════════════════════════
   ARÈTE — Core line · v5 script (white)
   Assets → arete-core.js
   · countdown (leest window.ARETE_OFFER_END, gezet door de header)
   · header (krimpen bij scroll, mobiel menu, --ac-hdr-h)
   · cart drawer (buy 2 get 1, gravering, besparing, guarantee)
   · quick add ([data-ac-add])
   · verzending: [data-ac-ship] (deadline vandaag) + [data-ac-arrive] (leverdatum)
     leest window.ARETE_SHIP = {cutoff:14, lead:2} uit de header
   Veilig om meerdere keren te laden.
   ════════════════════════════════════════════════════════════ */
(function(){
  if(window.__AC_CORE) return; window.__AC_CORE = true;

  function $(s,r){ return (r||document).querySelector(s); }
  function $$(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  function post(url,data){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); });
  }

  /* ── geld: leer het formaat van de winkel uit een gerenderde prijs ── */
  var CURR=null;
  function learn(str){
    if(CURR||!str) return;
    str=String(str).trim().replace(/^[+\u2212-]\s*/,'');
    var m=str.match(/[\d.,]+/); if(!m) return;
    var n=m[0], i=str.indexOf(n);
    CURR={pre:str.slice(0,i), post:str.slice(i+n.length), dec:(n.lastIndexOf(',')>n.lastIndexOf('.')&&n.length-n.lastIndexOf(',')===3)?',':'.'};
  }
  function money(c){
    c=Math.round(c||0);
    if(!CURR){ var el=document.querySelector('[data-ac-money]'); if(el) learn(el.textContent); }
    var v=(c/100).toFixed(2);
    if(!CURR) return '£'+v;
    if(CURR.dec===',') v=v.replace('.',',');
    return CURR.pre+v+CURR.post;
  }
  window.AreteMoney=money;

  /* ════════ COUNTDOWN ════════ */
  function endTime(){
    var e=window.ARETE_OFFER_END; if(!e) return null;
    if(e==='daily'){
      /* seconden tot 23:59:59 in Londen, ongeacht waar de bezoeker zit */
      var now=new Date(), h=0, m=0, s=0;
      try{
        new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'})
          .formatToParts(now).forEach(function(p){ if(p.type==='hour') h=+p.value; if(p.type==='minute') m=+p.value; if(p.type==='second') s=+p.value; });
      }catch(err){ h=now.getHours(); m=now.getMinutes(); s=now.getSeconds(); }
      return now.getTime() + (86399-(h*3600+m*60+s))*1000 + 999;
    }
    e=String(e).replace(/T(\d{1,2})[.,](\d{2})/,'T$1:$2').replace(/T(\d):/,'T0$1:');
    var t=Date.parse(e); return isNaN(t)?null:t;
  }
  function pad(x){ return (x<10?'0':'')+x; }

  /* ── tijd in Londen ── */
  var DAYN=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
      DAYS3=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], MON3=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function uk(ms){
    var d=new Date(ms==null?Date.now():ms), o={};
    try{
      new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'})
        .formatToParts(d).forEach(function(p){ o[p.type]=+p.value; });
    }catch(e){ o={year:d.getFullYear(),month:d.getMonth()+1,day:d.getDate(),hour:d.getHours(),minute:d.getMinutes(),second:d.getSeconds()}; }
    var day=new Date(Date.UTC(o.year,o.month-1,o.day,12));
    return {day:day,wd:day.getUTCDay(),h:o.hour,m:o.minute,s:o.second};
  }
  function addDays(d,n){ return new Date(d.getTime()+n*86400000); }
  function dayDiff(a,b){ return Math.round((b-a)/86400000); }
  function fmtDay(d){ return DAYS3[d.getUTCDay()]+' '+d.getUTCDate()+' '+MON3[d.getUTCMonth()]; }
  function workdays(d,n){ while(n>0){ d=addDays(d,1); if(d.getUTCDay()!==0&&d.getUTCDay()!==6) n--; } return d; }
  function shipInfo(){
    var S=window.ARETE_SHIP||{}, cut=+S.cutoff||14, lead=S.lead==null?2:+S.lead, t=uk();
    var work=t.wd>0&&t.wd<6, secs=t.h*3600+t.m*60+t.s, today=work&&secs<cut*3600, disp=t.day;
    if(!today){ disp=workdays(t.day,1); }
    var left=today?cut*3600-secs:0, when=dayDiff(t.day,disp);
    return {today:today,left:left,dispatch:disp,word:today?'today':(when===1?'tomorrow':DAYN[disp.getUTCDay()]),
            arrive:function(extra){ return fmtDay(workdays(disp,lead+(extra||0))); }};
  }
  window.AreteShip=shipInfo;
  function shipTick(){
    var I=shipInfo();
    $$('[data-ac-ship]').forEach(function(e){
      var hh=Math.floor(I.left/3600), mm=Math.floor(I.left%3600/60);
      e.innerHTML = I.today ? 'Order within <b>'+(hh?hh+'h ':'')+mm+'m</b> \u2014 ships today' : 'Order now \u2014 ships <b>'+I.word+'</b>';
    });
    $$('[data-ac-arrive]').forEach(function(e){ e.textContent=I.arrive(+e.getAttribute('data-ac-arrive')||0); });
  }
  ready(function(){ shipTick(); setInterval(shipTick,30000); });
  function tick(){
    var END=endTime(), timers=$$('[data-ac-timer]');
    if(!END){ timers.forEach(function(t){ t.hidden=true; }); return; }
    timers.forEach(function(t){ t.hidden=false; });
    var now=Date.now(), ms=Math.max(0,END-now), t=Math.floor(ms/1000),
        d=Math.floor(t/86400), h=Math.floor(t%86400/3600), m=Math.floor(t%3600/60), s=t%60;
    var str=(d?d+'d ':'')+pad(h)+':'+pad(m)+':'+pad(s);
    $$('[data-ac-cd]').forEach(function(e){ e.textContent=str; });
    var dw=$$('[data-ac-dwrap]'); dw.forEach(function(e){ e.hidden=!d; });
    $$('[data-ac-d]').forEach(function(e){ e.textContent=d; });
    $$('[data-ac-h]').forEach(function(e){ e.textContent=pad(dw.length?h:d*24+h); });
    $$('[data-ac-m]').forEach(function(e){ e.textContent=pad(m); });
    $$('[data-ac-s]').forEach(function(e){ e.textContent=pad(s); });
    var a=new Date(now); a.setHours(0,0,0,0);
    var b=new Date(END); b.setHours(0,0,0,0);
    var days=window.ARETE_OFFER_END==='daily'?0:Math.round((b-a)/86400000);
    var label = ms<=0 ? 'Offer ended' : days<=0 ? 'Ends today' : days===1 ? 'Ends tomorrow' : 'Ends in '+days+' days';
    var word  = ms<=0 ? 'ended' : days<=0 ? 'today' : days===1 ? 'tomorrow' : 'in '+days+' days';
    var ed=uk(END-1), td=uk(now), dd=dayDiff(td.day,ed.day);
    var dname = ms<=0 ? 'ended' : window.ARETE_OFFER_END==='daily'||dd<=0 ? 'tonight' : dd===1 ? 'tomorrow' : DAYN[ed.wd];
    $$('[data-ac-day]').forEach(function(e){ e.textContent=dname; });
    $$('[data-ac-label]').forEach(function(e){ e.textContent=label; });
    $$('[data-ac-when]').forEach(function(e){ e.textContent=word; });
    document.documentElement.classList.toggle('ac-ended', ms<=0);
  }
  ready(function(){ tick(); setInterval(tick,1000); });

  /* ════════ HEADER ════════ */
  /* Werkt ook opnieuw als de theme-editor de header herlaadt (shopify:section:load). */
  var HDR={small:false,rot:null};
  function hdrEl(){ return $('#acHdr'); }
  function hdrSetH(){ var h=hdrEl(); if(h) document.documentElement.style.setProperty('--ac-hdr-h', h.getBoundingClientRect().height+'px'); }
  function hdrFix(){
    var h=hdrEl(); if(!h) return;
    /* vaste header + even hoge spacer (sticky werkt niet in Horizon door wrappers met overflow) */
    var sp=h.previousElementSibling;
    if(!sp || !sp.classList.contains('ac-hdr-spacer')){ sp=document.createElement('div'); sp.className='ac-hdr-spacer'; sp.setAttribute('aria-hidden','true'); h.parentNode.insertBefore(sp,h); }
    $$('.ac-hdr-spacer').forEach(function(x){ if(x!==sp) x.remove(); });
    h.classList.add('ac-fixed-hdr');
    if(!h.classList.contains('small')) sp.style.height=h.getBoundingClientRect().height+'px';
    hdrSetH();
  }
  function initHeader(){
    var h=hdrEl(); if(!h) return;
    hdrFix();
    if(h.dataset.acInit) return; h.dataset.acInit='1';
    if('ResizeObserver' in window) new ResizeObserver(hdrSetH).observe(h);
    h.classList.toggle('small',HDR.small);
    var ann=$('#acAnn',h);
    if(HDR.rot) clearInterval(HDR.rot);
    if(ann && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      var ms=$$('span[data-msg]',ann), i=0;
      if(ms.length>1) HDR.rot=setInterval(function(){ ms[i].classList.remove('on'); i=(i+1)%ms.length; ms[i].classList.add('on'); },4000);
    }
    var b=$('#acBurger',h), m=$('#acMnav',h), mo=$('#acMov',h), mx=$('#acMnavX',h);
    function mnav(o){ if(!m) return; m.classList.toggle('open',o); if(mo) mo.classList.toggle('open',o); if(b) b.setAttribute('aria-expanded',String(o)); document.documentElement.style.overflow=o?'hidden':''; }
    if(b&&m) b.addEventListener('click',function(){ mnav(!m.classList.contains('open')); });
    if(mo) mo.addEventListener('click',function(){ mnav(false); });
    if(mx) mx.addEventListener('click',function(){ mnav(false); });
    initMega();
  }
  function initMega(){
    var b=$('#acShop'), m=$('#acMega'), t=null; if(!b||!m||b.dataset.acInit) return; b.dataset.acInit='1';
    function set(o){ m.classList.toggle('open',o); b.setAttribute('aria-expanded',String(o)); }
    var hov=0;
    b.addEventListener('click',function(){ var o=m.classList.contains('open'); if(o && Date.now()-hov>400) set(false); else set(true); });
    if(matchMedia('(hover:hover)').matches){
      b.addEventListener('mouseenter',function(){ clearTimeout(t); if(!m.classList.contains('open')) hov=Date.now(); set(true); });
      m.addEventListener('mouseenter',function(){ clearTimeout(t); });
      [b,m].forEach(function(el){ el.addEventListener('mouseleave',function(){ t=setTimeout(function(){ set(false); },180); }); });
    }
  }
  ready(function(){
    initHeader();
    addEventListener('resize',hdrFix); addEventListener('load',hdrFix);
    addEventListener('scroll',function(){
      var s=(pageYOffset||document.documentElement.scrollTop)>60, h=hdrEl();
      if(s!==HDR.small){ HDR.small=s; if(h) h.classList.toggle('small',s); setTimeout(hdrSetH,380); }
    },{passive:true});
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ var m=$('#acMega'); if(m) m.classList.remove('open'); } });
    document.addEventListener('shopify:section:load',function(){ setTimeout(function(){ initHeader(); tick(); shipTick(); },30); });
  });

  /* ════════ CART ════════ */
  var Cart={ open:function(){}, close:function(){}, refresh:function(o){ if(o) location.href='/cart'; },
    add:function(items,btn,noOpen){
      return post('/cart/add.js',{items:items}).then(function(){ Cart.refresh(!noOpen); })
        .catch(function(err){ if(btn) btn.classList.remove('busy'); alertLite(err); });
    }
  };
  function alertLite(err){
    var msg=(err&&(err.description||err.message))||'Could not add to your bag.';
    var n=document.createElement('div');
    n.setAttribute('role','status');
    n.style.cssText='position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:300;background:#1d1d1f;color:#fff;font:13px/1.4 -apple-system,Inter,Arial,sans-serif;padding:12px 18px;border-radius:999px;max-width:90vw';
    n.textContent=msg; document.body.appendChild(n); setTimeout(function(){ n.remove(); },3200);
  }
  window.AreteCart=Cart;

  ready(function(){
    var dr=$('#acCart'); if(!dr) return;
    var C=dr.dataset;
    var GROUP=parseInt(C.group,10)||3;          /* buy 2 get 1 → 3 */
    var LEAD=parseInt(C.lead,10)||2;            /* werkdagen tot levering */
    var ENGX=parseInt(C.engextra,10)||1;        /* extra dag bij gravering */
    var HOME=C.home||'/collections/all';
    var ov=$('#acOv'), body=$('#acBody'), foot=$('#acFoot'), cnt=$('#acCount'), bag=$('#acBag'),
        lad=$('#acLad'), ladT=$('#acLadT'), segs=$$('#acLad .ac-lad-tr span'), marks=$$('#acLad .ac-lad-mk span'),
        up=$('#acUp'), upIni=$('#acUpIni'), upAdd=$('#acUpAdd'), upCoin=$('#acUpCoin'),
        xs=$('#acXs'), xsT=$('#acXsT'), gu=$('#acGu'),
        save=$('#acSave'), saveV=$('#acSaveV'), saveS=$('#acSaveS'),
        sub=$('#acSub'), eta=$('#acEta'), note=$('#acNote'), co=$('#acCo'), coP=$('#acCoP'), discRow=$('#acDiscRow'), discV=$('#acDiscV');
    var ENGVID=up?String(up.dataset.vid):'', GUVID=gu?String(gu.dataset.vid):'';
    var GUKEY=null, lastTotal=null, CMP={}, cmpBusy={};
    $$('[data-ac-money]',dr).forEach(function(e){ learn(e.textContent); });

    function isGu(it){ return (GUVID && String(it.variant_id)===GUVID) || /guarantee|insurance/i.test(it.product_title||''); }
    function isAddon(it){ return (ENGVID && String(it.variant_id)===ENGVID) || /engrav|initials/i.test((it.product_type||'')+' '+(it.product_title||'')); }
    function prop(it,re){ if(!it.properties) return ''; for(var k in it.properties){ if(re.test(k)&&it.properties[k]) return String(it.properties[k]); } return ''; }

    function arrive(extra){ return shipInfo().arrive(extra); }

    function open(){ ov.classList.add('open'); dr.classList.add('open'); dr.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden';
      document.dispatchEvent(new CustomEvent('arete:cartopen')); }
    function close(){ ov.classList.remove('open'); dr.classList.remove('open'); dr.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }
    function badge(n){
      if(!bag) return; var b=bag.querySelector('.ac-cc');
      if(n>0){ if(!b){ b=document.createElement('span'); b.className='ac-cc'; bag.appendChild(b); } b.textContent=n; }
      else if(b) b.remove();
    }

    /* vergelijkprijzen ophalen per product (cart.js geeft ze niet mee) */
    function loadCmp(items){
      var need=[];
      items.forEach(function(it){ if(it.handle && CMP[it.handle]===undefined && !cmpBusy[it.handle]) need.push(it.handle); });
      if(!need.length) return Promise.resolve(false);
      return Promise.all(need.map(function(h){
        cmpBusy[h]=1;
        return fetch('/products/'+h+'.js').then(function(r){ return r.ok?r.json():null; }).then(function(p){
          var map={}; if(p&&p.variants) p.variants.forEach(function(v){ if(v.compare_at_price>v.price) map[v.id]=v.compare_at_price; });
          CMP[h]=map;
        }).catch(function(){ CMP[h]={}; });
      })).then(function(){ return true; });
    }
    function cmpOf(it){ var m=CMP[it.handle]; return m&&m[it.variant_id]?m[it.variant_id]:0; }

    var lastCart=null;
    function render(cart){
      lastCart=cart;
      document.dispatchEvent(new CustomEvent('arete:cart',{detail:cart}));
      badge(cart.item_count);
      if(cnt) cnt.textContent = cart.item_count?'('+cart.item_count+')':'';

      var bands=[], addons=[], inCart={}, units=[], qty=0;
      GUKEY=null;
      cart.items.forEach(function(it){
        if(isGu(it)){ GUKEY=it.key; return; }
        inCart[it.product_id]=true;
        if(isAddon(it)){ addons.push(it); return; }
        it._subs=[]; bands.push(it); qty+=it.quantity;
        for(var q=0;q<it.quantity;q++) units.push(it.original_price||it.price);
      });
      if(gu){ gu.classList.toggle('on',!!GUKEY); gu.setAttribute('aria-pressed',GUKEY?'true':'false'); }

      if(!bands.length && !addons.length){
        body.innerHTML='<div class="ac-empty"><span class="m">ARÈTE</span><p class="h">Your bag is empty.</p>'
          +'<p>Every band is half price right now, and the third one is free.</p><a href="'+esc(HOME)+'">Shop all bands</a></div>';
        foot.hidden=true; lad.hidden=true; if(up) up.hidden=true; if(xs) xs.hidden=true;
        return;
      }

      addons.forEach(function(a){
        var ini=prop(a,/initial|engrav/i), host=null;
        if(ini) host=bands.filter(function(b){ return prop(b,/engrav|initial/i).toUpperCase()===ini.toUpperCase() && !b._subs.length; })[0];
        if(!host) host=bands.filter(function(b){ return !b._subs.length; })[0]||bands[0];
        if(host) host._subs.push(a); else { a._subs=[]; bands.push(a); }
      });

      /* 2+1: wie is gratis? (goedkoopste eerst). Als Shopify de korting al toepast, telt die. */
      var shopDisc=cart.total_discount||0, freeN=Math.floor(qty/GROUP), alloc={}, estDisc=0;
      if(!shopDisc && freeN>0){
        var pool=[]; bands.forEach(function(b){ if(isAddon(b)) return; for(var q=0;q<b.quantity;q++) pool.push(b); });
        pool.sort(function(a,b){ return (a.original_price||a.price)-(b.original_price||b.price); });
        for(var fi=0;fi<freeN && fi<pool.length;fi++){ var fb=pool[fi]; alloc[fb.key]=(alloc[fb.key]||0)+1; estDisc+=(fb.original_price||fb.price); }
      }
      var h='';
      bands.forEach(function(it){
        var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2'):'';
        var kill=[it.key].concat(it._subs.map(function(s){ return s.key; })).join('|');
        var nFree=alloc[it.key]||0, unit=(it.original_price||it.price);
        var full=cmpOf(it)*it.quantity, isFree=(it.final_line_price===0 && it.original_line_price>0) || (nFree>0 && nFree>=it.quantity);
        var linePrice=it.final_line_price-(nFree*unit);
        var nm=String(it.product_title||''), parts=nm.split(' Band '), title=parts.length>1?parts[0]+' Band':nm, sv=parts.length>1?parts[1]:'';
        var CLM={Noir:'black clasp',Silver:'silver clasp',Gold:'gold clasp',Rose:'rose gold clasp'}; if(sv){ var sw=sv.split(' '), lw=sw[sw.length-1]; if(CLM[lw]) sv=(sw.length>1?sw.slice(0,-1).join(' ')+' \u00b7 ':'')+CLM[lw]; }
        if(it.variant_title && it.variant_title!=='Default Title') sv=(sv?sv+' · ':'')+it.variant_title;
        var was = full>it.final_line_price ? full : (it.original_line_price>it.final_line_price ? it.original_line_price : 0);
        h+='<div class="ac-ci"><div class="ac-ci-m">'
          +'<a class="ac-ci-i" href="'+esc(it.url)+'">'+(img?'<img src="'+esc(img)+'" alt="">':'')+(isFree?'<span class="ac-ci-f">Free</span>':'')+'</a>'
          +'<div class="ac-cm"><b>'+esc(title)+'</b>'+(sv?'<span class="cv">'+esc(sv)+'</span>':'')
          +'<span class="ac-cpr">'+(was?'<s>'+money(was)+'</s>':'')
          +(isFree?'<b class="free">Free</b>':'<b>'+money(linePrice)+'</b>'+(nFree?'<em class="fr">'+nFree+' free</em>':''))+'</span>'
          +'<div class="ac-crow"><span class="ac-cq">'
          +'<button type="button" data-k="'+esc(it.key)+'" data-q="'+(it.quantity-1)+'" aria-label="One less">−</button>'
          +'<span>'+it.quantity+'</span>'
          +'<button type="button" data-k="'+esc(it.key)+'" data-q="'+(it.quantity+1)+'" aria-label="One more">+</button></span>'
          +'<button type="button" class="ac-cdel" data-kill="'+esc(kill)+'">Remove</button></div></div></div>';
        it._subs.forEach(function(s){
          var ini=prop(s,/initial|engrav/i);
          h+='<div class="ac-sub"><span class="ac-coin">'+esc(ini||'···')+'</span>'
            +'<span class="t"><b>Engraved '+esc(ini)+'</b><span>Laser-cut into this clasp</span></span>'
            +'<span class="p">+'+money(s.final_line_price)+'</span>'
            +'<button type="button" class="x" data-kill="'+esc(s.key)+'" aria-label="Remove engraving">&times;</button></div>';
        });
        h+='</div>';
      });
      body.innerHTML=h;
      foot.hidden=false;

      /* ladder: buy 2, get 1 free */
      var free=Math.floor(qty/GROUP), k=qty%GROUP;
      lad.hidden = qty===0;
      var done = (k===0 && free>0);
      var lit = done ? GROUP : k;
      segs.forEach(function(s,i){ s.classList.toggle('on', i<lit); });
      marks.forEach(function(s,i){ s.classList.toggle('on', i<lit); });
      var wasDone=lad.classList.contains('done');
      lad.classList.toggle('done', done);
      if(done){
        ladT.innerHTML = '<span class="ok"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span><b>'+(free>1 ? 'Nice, '+free+' free bands unlocked' : 'Nice, your 3rd band is free')+'</b>';
        if(!wasDone && !matchMedia('(prefers-reduced-motion: reduce)').matches){
          var c=document.createElement('span'); c.className='ac-confetti';
          for(var ci=0;ci<14;ci++){ var d=document.createElement('i'); d.style.setProperty('--x',(Math.random()*200-100)+'px'); d.style.setProperty('--r',(Math.random()*540-270)+'deg'); d.style.setProperty('--d',(Math.random()*0.25)+'s'); d.style.background=['#1a8a3f','#34c759','#0f0f10','#e10600','#f5c542'][ci%5]; c.appendChild(d); }
          lad.appendChild(c); setTimeout(function(){ c.remove(); },1400);
        }
      } else {
        var n=GROUP-1-k;
        ladT.innerHTML = n<=0
          ? 'Add <b>1 more band</b> and it’s <em>free</em>'
          : 'Add <b>'+n+' more band'+(n>1?'s':'')+'</b>, then the next one is <em>free</em>';
        if(free>0) ladT.innerHTML='<b class="g">'+free*GROUP+' for £'+(free*79.9).toFixed(2)+' ✓</b> · '+ladT.innerHTML;
      }

      /* gravering-upsell: alleen als er een band zonder initialen is */
      var bare=bands.some(function(b){ return !isAddon(b) && !prop(b,/engrav|initial/i); });
      if(up) up.hidden=!bare;
      var engraved=bands.some(function(b){ return b._subs.length; });

      /* cross-sell */
      if(xs){
        var any=false;
        $$('.ac-xc',xs).forEach(function(c){ var mine=inCart[c.dataset.pid]; c.hidden=!!mine; if(!mine) any=true; });
        xs.hidden=!any || (k===0 && free>0);
        if(xsT) xsT.textContent = (k===GROUP-1) ? 'Pick your free band' : (k===GROUP-2 ? 'Add one more, then one free' : 'Add another band');
      }

      /* totalen */
      var disc=cart.total_discount||0;
      var total=cart.total_price-(disc?0:estDisc);
      sub.textContent=money(total); if(coP) coP.textContent=money(total);
      if(eta) eta.textContent=arrive(engraved?ENGX:0);
      if(co && lastTotal!==null && total!==lastTotal){ co.classList.remove('flash'); void co.offsetWidth; co.classList.add('flash'); }
      lastTotal=total;
      var shownDisc=disc||estDisc;
      if(discRow){ discRow.hidden=!shownDisc; if(discV) discV.textContent='−'+money(shownDisc); }

      /* geschatte gratis band als Shopify hem nog niet in de cart toepast */
      units.sort(function(a,b){ return a-b; });
      var est=estDisc;
      var clr=0; bands.forEach(function(b){ var c=cmpOf(b); if(c>b.original_price) clr+=(c-b.original_price)*b.quantity; });
      var s=clr+disc+estDisc;
      if(save){
        save.hidden=s<=0;
        if(s>0){
          saveV.textContent=money(s);
          saveS.textContent = (clr&&(disc||est)) ? 'Clearance price + free band' : (clr ? 'Clearance price' : 'Buy 2, get 1 free');
        }
      }
      if(note){
        note.hidden=!(est>0);
        if(est>0) note.textContent='Your free band ('+money(est)+') comes off automatically at checkout.';
      }

      $$('[data-k]',body).forEach(function(b){
        b.addEventListener('click',function(){ b.disabled=true;
          post('/cart/change.js',{id:b.dataset.k,quantity:+b.dataset.q}).then(render).catch(function(){ refresh(false); }); });
      });
      $$('[data-kill]',body).forEach(function(b){
        b.addEventListener('click',function(){ b.disabled=true;
          var u={}; b.dataset.kill.split('|').forEach(function(k){ if(k) u[k]=0; });
          post('/cart/update.js',{updates:u}).then(render).catch(function(){ refresh(false); }); });
      });

      loadCmp(bands).then(function(changed){ if(changed && lastCart===cart) render(cart); });
    }

    function refresh(andOpen){
      return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); })
        .then(function(c){ render(c); if(andOpen) open(); });
    }
    Cart.open=open; Cart.close=close; Cart.refresh=refresh;
    Cart.get=function(){ return lastCart; };

    /* gravering vanuit de cart */
    if(up&&upIni&&upAdd){
      var L=function(){ return upIni.value.replace(/[^a-z]/gi,'').toUpperCase().slice(0,3); };
      upIni.addEventListener('input',function(){ var v=L(); if(upIni.value!==v) upIni.value=v; if(upCoin) upCoin.textContent=v||'MK'; upAdd.disabled=!v; });
      upAdd.addEventListener('click',function(){
        var v=L(); if(!v) return; upAdd.disabled=true; upAdd.textContent='…';
        var target=null;
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
          c.items.forEach(function(it){ if(!target && !isAddon(it) && !isGu(it) && !prop(it,/engrav|initial/i)) target=it; });
          if(!target) throw 0;
          var props={}; for(var k in (target.properties||{})) props[k]=target.properties[k]; props['Engraving']=v;
          return post('/cart/change.js',{id:target.key,properties:props,quantity:target.quantity});
        }).then(function(){ return post('/cart/add.js',{items:[{id:up.dataset.vid,quantity:1,properties:{'Initials':v}}]}); })
          .then(function(){ upIni.value=''; if(upCoin) upCoin.textContent='MK'; upAdd.textContent='Add'; refresh(false); })
          .catch(function(){ upAdd.textContent='Add'; upAdd.disabled=false; });
      });
    }

    /* delivery guarantee — standaard UIT, klant zet hem zelf aan */
    if(gu) gu.addEventListener('click',function(){
      if(gu.dataset.busy) return; gu.dataset.busy='1';
      var req = GUKEY ? post('/cart/update.js',{updates:(function(){ var u={}; u[GUKEY]=0; return u; })()})
                      : post('/cart/add.js',{items:[{id:gu.dataset.vid,quantity:1}]});
      req.then(function(){ delete gu.dataset.busy; refresh(false); }).catch(function(){ delete gu.dataset.busy; });
    });

    /* cross-sell + */
    if(xs) xs.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('.ac-xc-a'); if(!b) return;
      e.preventDefault(); e.stopPropagation(); b.textContent='✓';
      post('/cart/add.js',{items:[{id:b.dataset.vid,quantity:1}]}).then(function(){ b.textContent='+'; refresh(false); })
        .catch(function(err){ b.textContent='+'; alertLite(err); });
    });

    if(ov) ov.addEventListener('click',close);
    var x=$('#acClose'); if(x) x.addEventListener('click',close);
    if(bag) bag.addEventListener('click',function(e){ e.preventDefault(); refresh(true); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
    refresh(false);
  });

  /* ════════ QUICK ADD ════════ */
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('button[data-ac-add]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    b.classList.add('ok'); var t=b.textContent; b.textContent='✓';
    Cart.add([{id:+b.dataset.acAdd,quantity:1}],b,!!document.getElementById('acTray')).then(function(){ setTimeout(function(){ b.textContent=t; b.classList.remove('ok'); },1200); });
  });

  /* open cart vanaf elke knop met data-ac-open-cart */
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-ac-open-cart]'); if(!b) return;
    e.preventDefault(); Cart.refresh(true);
  });

  /* ════════ "YOUR THREE" TRAY (collectie-hero) ════════ */
  document.addEventListener('arete:cart',function(e){
    var tray=document.getElementById('acTray'); if(!tray) return;
    var cart=e.detail||{}, G=parseInt(tray.dataset.group,10)||3, bands=[];
    (cart.items||[]).forEach(function(it){
      if(/engrav|initials|guarantee|insurance/i.test((it.product_type||'')+' '+(it.product_title||''))) return;
      for(var q=0;q<it.quantity;q++) bands.push(it);
    });
    var n=bands.length, k=n%G, free=Math.floor(n/G);
    var show = (k===0&&n) ? bands.slice(-G) : bands.slice(n-k);
    $$('.ac-slot',tray).forEach(function(s,i){
      var it=show[i], img=s.querySelector('img');
      s.classList.toggle('full',!!it);
      if(it && it.image){
        if(!img){ img=document.createElement('img'); img.alt=''; s.appendChild(img); }
        img.src=it.image.replace(/(\.[a-z]+)(\?|$)/i,'_300x$1$2');
      } else if(img) img.remove();
      var plus=s.querySelector('.pl'); if(plus) plus.hidden=!!it;
    });
    var msg=document.getElementById('acTrayMsg');
    if(msg) msg.textContent = !n ? (msg.dataset.def||'Tap + on any band')
      : (k===0 ? free+' free band'+(free>1?'s':'')+' unlocked' : (k===G-1 ? 'Add 1 more \u2014 it\u2019s free' : 'Add '+(G-1-k)+' more \u00b7 the next is free'));
  });

  /* ════════ KLEUREN (kleurnaam → bolletje + kleurfamilie) ════════ */
  var COL={Ember:["#c9562a","orange"],Graphite:["#3a3b3d","grey"],Obsidian:["#1b1a18","black"],Black:["#1d1d1f","black"],Blue:["#2a4b8d","blue"],Cobalt:["#1f3fa0","blue"],Grey:["#8a8a88","grey"],Gray:["#8a8a88","grey"],Pink:["#e6a4b4","pink"],Ash:["#b9b5ad","grey"],Charcoal:["#333336","grey"],Green:["#4b6a3a","green"],Red:["#a3232b","red"],Sky:["#9cc2e0","blue"],Stone:["#cdbfa8","sand"],Citrus:["#d9c24a","yellow"],Flare:["#e0703a","orange"],Starlight:["#e9e2d6","white"],Storm:["#5a6570","grey"],Tide:["#2d5f6e","blue"],White:["#f1efe9","white"],Clover:["#3f7a4a","green"],Midnight:["#1f2a4a","navy"],Onyx:["#1d1d1f","black"],Beacon:["#e0a02a","yellow"],Rally:["#c02a2a","red"],Sakura:["#f0c4cf","pink"],Spectrum:["#6a4ac0","purple"],Torch:["#e05a2a","orange"],Alpine:["#dfe6ea","white"],Burgundy:["#6a1f2b","red"],Orange:["#e0703a","orange"],Pine:["#2f4a3a","green"],Sunrise:["#e8a15a","orange"],Dune:["#c7b08a","sand"],Fatigue:["#5b5a3c","green"],Navy:["#1f2a4a","navy"],Rust:["#9a4a2a","orange"],Anchor:["#2a3a4a","navy"],Azalea:["#e07a9a","pink"],Azure:["#3a8ad0","blue"],Denim:["#3a5a8a","blue"],Dusk:["#6a5a7a","purple"],Emerald:["#1f6a4a","green"],Fir:["#2a4a3a","green"],Glacier:["#cfe3ea","blue"],Lilac:["#b9a4d0","purple"],Lime:["#b8d04a","yellow"],Magenta:["#c02a8a","pink"],Merlot:["#5a1a2a","red"],Mint:["#aee0c8","green"],Moss:["#5a6b3a","green"],Plum:["#5a2a4a","purple"],Rosewood:["#8a4a4a","red"],Sage:["#9aab8a","green"],Seasalt:["#e6e8e4","white"],Slate:["#56606a","grey"],Snow:["#f4f4f2","white"],Yule:["#8a1a1a","red"],Crimson:["#9a1a2a","red"],Forest:["#2a4a2a","green"],Khaki:["#a8986a","sand"],LeMans:["#1a3a6a","navy"],Teal:["#2a7a7a","blue"],Field:["#6a7a4a","green"],Marine:["#24357a","navy"],Pewter:["#8a8c8e","grey"],Tuxedo:["#111111","black"],Acid:["#c8e02a","yellow"],Petal:["#f0c0c8","pink"],Olive:["#5a5f3a","green"],Purple:["#5a3a8a","purple"],Sand:["#cdbfa8","sand"],Beige:["#d8cbb3","sand"],Brown:["#6b4a32","sand"],Yellow:["#e0c040","yellow"],Silver:["#c9c9c9","grey"],Gold:["#d4b06a","yellow"]};
  var FAMS=[["black","Black","#1d1d1f"],["white","White","#f1efe9"],["grey","Grey","#8a8c8e"],["navy","Navy","#1f2a4a"],["blue","Blue","#3a8ad0"],["green","Green","#4b6a3a"],["red","Red","#a3232b"],["pink","Pink","#eaa6b8"],["orange","Orange","#e0703a"],["yellow","Yellow","#dcc24a"],["purple","Purple","#7a5aa0"],["sand","Sand","#c7b08a"]];
  function colourOf(name){
    var w=String(name||'').replace(/[^A-Za-z ]/g,' ').split(/\s+/);
    for(var i=w.length-1;i>=0;i--){ var k=w[i].charAt(0).toUpperCase()+w[i].slice(1).toLowerCase(); if(COL[w[i]]) k=w[i]; if(COL[k]) return {hex:COL[k][0],fam:COL[k][1]}; }
    return null;
  }
  window.AreteColour=colourOf;

  /* ════════ COLLECTIE: kleurbolletjes, kleurfilter, doorscrollen ════════ */
  ready(function(){
    var feed=$('[data-ac-feed]'); if(!feed) return;
    var cards=$$('[data-ac-card]',feed), PAGE=24, shown=PAGE, sel=[];
    try{ var qc=new URLSearchParams(location.search).get('colour'); if(qc) sel=[qc.toLowerCase()]; }catch(e){}
    /* één kaart per model + kleur; de clasp kies je op de productpagina */
    var ALLN=cards.length, SOLDN=cards.filter(function(c){ return c.classList.contains('sold'); }).length;
    (function(){
      var groups={}, order=[];
      cards.forEach(function(c){ var k=(c.dataset.m||'')+'|'+(c.dataset.c||c.querySelector('.cw')&&c.querySelector('.cw').textContent||''); if(!groups[k]){ groups[k]=[]; order.push(k); } groups[k].push(c); });
      var keep=[];
      order.forEach(function(k){
        var g=groups[k]; if(g.length===1){ keep.push(g[0]); return; }
        var rep=g.filter(function(c){ return !c.classList.contains('sold'); })[0]||g[0];
        g.forEach(function(c){ if(c!==rep) c.remove(); });
        var cw=rep.querySelector('.cw'); if(cw) cw.textContent=(rep.dataset.c||'')+' \u00b7 '+g.length+' clasp colours';
        keep.push(rep);
      });
      cards=keep;
    })();
    /* 'All bands': eerst gemixt (om en om per model) */
    if(feed.hasAttribute('data-ac-mix')){
      var q={}, order=[];
      cards.forEach(function(c){ var m=c.dataset.m||''; if(!q[m]){ q[m]=[]; order.push(m); } q[m].push(c); });
      order.sort(function(a,b){ return q[b].length-q[a].length; });
      var mixed=[], left=true; while(left){ left=false; order.forEach(function(m){ if(q[m].length){ mixed.push(q[m].shift()); left=true; } }); }
      mixed.forEach(function(c){ feed.appendChild(c); }); cards=mixed;
    }
    /* kaart 1, 4, 5, 8, 9, 12 …: tweede foto (om de pols) vooraan */
    cards.forEach(function(c,i){
      var pos=i+1, m4=pos%4; if(m4!==1 && m4!==0) return;
      var a=c.querySelector('img[data-ac-main]'), b=c.querySelector('img.alt'); if(!a||!b) return;
      var as=a.getAttribute('src'), ass=a.getAttribute('srcset')||'';
      a.setAttribute('src',b.getAttribute('src')); a.setAttribute('srcset',b.getAttribute('data-srcset')||'');
      b.setAttribute('src',as); b.setAttribute('data-srcset',ass);
    });
    /* kleurbolletjes per model */
    var byM={};
    cards.forEach(function(c){ var m=c.dataset.m, col=c.dataset.c; if(!m) return; (byM[m]=byM[m]||[]); if(col && byM[m].indexOf(col)<0) byM[m].push(col); c._fam=c.dataset.fam||(colourOf(col)||{}).fam||''; });
    cards.forEach(function(c){
      var sw=c.querySelector('[data-ac-sw]'); if(!sw) return;
      var list=byM[c.dataset.m]||[]; if(list.length<2){ sw.remove(); return; }
      sw.innerHTML=list.slice(0,5).map(function(n){ var x=colourOf(n); return '<i title="'+esc(n)+'" style="background:'+(x?x.hex:'#ccc')+'"></i>'; }).join('')+'<em>'+list.length+' colours</em>';
    });
    /* kleurfilter */
    var soldN=SOLDN;
    $$('[data-ac-sold]').forEach(function(e){ e.textContent=soldN; });
    $$('[data-ac-total]').forEach(function(e){ e.textContent=ALLN; });
    $$('[data-ac-stockwrap]').forEach(function(e){ e.hidden = soldN<1; });
    $$('[data-ac-today]').forEach(function(e){ var d=new Date(); e.textContent=d.getDate()+' '+['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()]; });
    var grids=$$('[data-ac-cgrid]'), act=$('[data-ac-active]'), cnts=$$('[data-ac-count]'), more=$('[data-ac-more]'), empty=$('[data-ac-empty]');
    var present={}; cards.forEach(function(c){ if(c._fam) present[c._fam]=1; });
    var gh=FAMS.filter(function(f){ return present[f[0]]; }).map(function(f){ return '<button type="button" data-f="'+f[0]+'" title="'+f[1]+'"><i style="background:'+f[2]+'"></i><span>'+f[1]+'</span></button>'; }).join('');
    grids.forEach(function(g){ g.innerHTML=gh; var box=g.closest('[data-ac-cbox]'); if(box && Object.keys(present).length<2) box.hidden=true; });
    function visible(){ return cards.filter(function(c){ return !sel.length || sel.indexOf(c._fam)>-1; }); }
    function paint(){
      var vis=visible();
      cards.forEach(function(c){ c.hidden=true; });
      vis.forEach(function(c,i){ c.hidden=i>=shown; });
      cnts.forEach(function(c){ c.textContent=vis.length+' band'+(vis.length===1?'':'s'); });
      if(empty) empty.hidden=!!vis.length || !sel.length;
      if(more) more.innerHTML = vis.length>shown ? 'Showing '+shown+' of '+vis.length+'<span class="bar"><i style="width:'+(shown/vis.length*100)+'%"></i></span>' : (vis.length>PAGE?'Showing all '+vis.length:'');
      grids.forEach(function(g){ $$('button',g).forEach(function(b){ b.classList.toggle('on',sel.indexOf(b.dataset.f)>-1); }); });
      $$('[data-ac-cclear]').forEach(function(b){ if(!b.closest('[data-ac-empty]')) b.hidden=!sel.length; });
      $$('[data-ac-fn]').forEach(function(e){ e.hidden=!sel.length; e.textContent=sel.length; });
      if(act) act.innerHTML=sel.map(function(f){ var F=FAMS.filter(function(x){ return x[0]===f; })[0]; return '<button type="button" data-rm="'+f+'"><i style="background:'+F[2]+'"></i>'+F[1]+'</button>'; }).join('');
    }
    function top(){ var g=$('[data-ac-feed]'); var y=g.getBoundingClientRect().top+pageYOffset-(parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ac-hdr-h'))||60)-80; if(pageYOffset>y) scrollTo({top:y,behavior:'smooth'}); }
    document.addEventListener('click',function(e){
      var b=e.target.closest('[data-ac-cgrid] [data-f]'); if(b){ var f=b.dataset.f, i=sel.indexOf(f); if(i>-1) sel.splice(i,1); else sel.push(f); shown=PAGE; paint(); return; }
      if(e.target.closest('[data-ac-cclear]')){ sel=[]; shown=PAGE; paint(); return; }
      var r=e.target.closest('[data-rm]'); if(r && act && act.contains(r)){ sel.splice(sel.indexOf(r.dataset.rm),1); shown=PAGE; paint(); return; }
      if(e.target.closest('[data-ac-fopen]')){ e.preventDefault(); sheet(true); return; }
      if(e.target.closest('[data-ac-fclose]')){ e.preventDefault(); sheet(false); if(e.target.closest('[data-ac-fdone]')) top(); }
    });
    var sh=$('[data-ac-sheet]'), sov=$('[data-ac-sov]');
    function sheet(o){ if(!sh) return; sh.classList.toggle('open',o); if(sov) sov.classList.toggle('open',o); document.documentElement.style.overflow=o?'hidden':''; }
    /* zwevende filterknop (mobiel) zodra de filterbalk uit beeld is */
    var bar=$('[data-ac-mbar]'), pill=$('[data-ac-pill]');
    if(bar && pill && 'IntersectionObserver' in window){
      new IntersectionObserver(function(en){ pill.classList.toggle('show', !en[0].isIntersecting && en[0].boundingClientRect.top<0); }).observe(bar);
    }
    /* desktop: filterbalk vastzetten onder de header (zonder sticky) */
    var fb=$('.ac-fbar');
    if(fb){
      var ph=document.createElement('div'); fb.parentNode.insertBefore(ph,fb);
      function fbar(){
        if(innerWidth<=820){ fb.classList.remove('ac-fb-fixed'); ph.style.height='0'; fb.style.top=''; return; }
        var hh=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ac-hdr-h'))||64;
        var fixed=ph.getBoundingClientRect().top<=hh;
        if(fixed && !fb.classList.contains('ac-fb-fixed')){ ph.style.height=fb.offsetHeight+'px'; fb.classList.add('ac-fb-fixed'); }
        else if(!fixed && fb.classList.contains('ac-fb-fixed')){ fb.classList.remove('ac-fb-fixed'); ph.style.height='0'; }
        fb.style.top = fb.classList.contains('ac-fb-fixed') ? hh+'px' : '';
      }
      addEventListener('scroll',fbar,{passive:true}); addEventListener('resize',fbar); fbar();
    }
    if(more && 'IntersectionObserver' in window){
      new IntersectionObserver(function(en){ if(en[0].isIntersecting && visible().length>shown){ shown+=PAGE; paint(); } },{rootMargin:'700px'}).observe(more);
    } else { shown=9999; }
    paint();
  });
})();
